import type { MouseEvent } from 'react';

/**
 * Blur the clicked element only when activated by mouse (detail > 0),
 * preserving focus for keyboard users (Enter/Space where detail === 0).
 */
export const blurOnClick = (e: MouseEvent<HTMLElement>) => {
  if (e.detail > 0) e.currentTarget.blur();
};
